import { getTheme } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPText, IPTooltipHost } from 'baseComponents';
import { IPPersona, IPPersonaSize } from 'baseComponents/Persona/IPPersona';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';
import Activity from 'models/activity';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toLocaleDateTimeMedium } from 'utils/datetime';

interface ISingleActivity {
  activity: Activity;
}

export const SingleActivity = (props: ISingleActivity) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['activity']);
  const theme = getTheme();
  const message = props.activity.getActivityTabText(appContext.globalDataCache);

  return (
    <IPStack>
      <IPStack
        horizontal
        tokens={globalStackTokensGapSmall}
        styles={{
          root: {
            borderWidth: 1,
            borderColor: appContext.useDarkMode ? theme.palette.themeDark : theme.palette.themeLight,
            background: appContext.useDarkMode ? theme.palette.themeDarker : theme.palette.themeLighter,
            borderStyle: 'solid',
            borderRadius: '3px',
            marginBottom: 10,
            padding: 2,
          },
        }}
      >
        <IPStack.Item>
          <IPPersona
            imageUrl={appContext.globalDataCache.users.getPhotoURLObj(props.activity.userId)}
            text={props.activity.getUserName(appContext.globalDataCache)}
            hidePersonaDetails={true}
            size={IPPersonaSize.size24}
          />
        </IPStack.Item>
        <IPStack.Item grow>
          <IPStack>
            <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
              <IPStack.Item>
                <IPText block nowrap variant="small">
                  {toLocaleDateTimeMedium(props.activity.created)}
                </IPText>
              </IPStack.Item>
              {props.activity.dismissed && (
                <IPStack.Item styles={{ root: { marginTop: 0 } }}>
                  <IPTooltipHost
                    content={t('activity:DismissedTooltip', {
                      date: toLocaleDateTimeMedium(props.activity.dismissed),
                    })}
                  >
                    <IPText variant="small">
                      <u>{t('activity:Dismissed')}</u>
                    </IPText>
                  </IPTooltipHost>
                </IPStack.Item>
              )}
            </IPStack>
            <IPStack.Item>
              <IPTooltipHost content={message}>
                <IPText block>{message}</IPText>
              </IPTooltipHost>
            </IPStack.Item>
          </IPStack>
        </IPStack.Item>
      </IPStack>
    </IPStack>
  );
};
